import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/customer_events`;

const model = abstractModel(resource);

model.getCustomerEvents = async (params) => {
  const newResource = `${resource}/events`;
  return model.get(params, { path: newResource });
};

export default model;
